import $ from "jquery"

function showPwError($field, message) {
  $field.addClass('is-invalid');
  var $existing = $field.next('.profile-field-error');
  if ($existing.length) {
    $existing.text(message);
  } else {
    $('<div class="profile-field-error text-danger small mt-1"></div>')
      .text(message)
      .insertAfter($field);
  }
}

function clearPwError($field) {
  $field.removeClass('is-invalid');
  $field.next('.profile-field-error').remove();
}

// One delegated handler supports auth buttons and existing profile icons.
$(document).on('click.pwToggle', '.auth-password-toggle, .toggle-password', function(event) {
  event.preventDefault();
  const $toggle = $(this);
  const $icon = $toggle.is('i') ? $toggle : $toggle.find('i');
  const target = $toggle.data('target') || $icon.data('target');
  const $input = $(target);
  if (!$input.length) return;
  const visible = $input.attr('type') === 'password';
  $input.attr('type', visible ? 'text' : 'password');
  $icon.toggleClass('fa-eye', visible).toggleClass('fa-eye-slash', !visible);
  $toggle.attr('aria-pressed', String(visible));
  $toggle.attr('aria-label', visible ? 'Hide password' : 'Show password');
});

window.initPasswordValidation = function() {
  var $password = $('#user_password');
  var $confirmation = $('#user_password_confirmation');

  // Clear errors on input
  $password.off('input.pwValidate').on('input.pwValidate', function() {
    if ($(this).val()) clearPwError($(this));
  });
  $confirmation.off('input.pwValidate').on('input.pwValidate', function() {
    if ($(this).val()) clearPwError($(this));
  });

  // Submit validation
  $(document)
    .off('submit.passwordValidate', '.profile-form')
    .on('submit.passwordValidate', '.profile-form', function(event) {
      var newPass = $password.val();
      var confirmPass = $confirmation.val();
      var hasError = false;

      if (newPass && !/(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(newPass)) {
        showPwError($password, 'Password must include at least 8 characters with both uppercase and lowercase letters.');
        hasError = true;
      }

      if (confirmPass && newPass !== confirmPass) {
        showPwError($confirmation, 'Password confirmation does not match.');
        hasError = true;
      }

      if (hasError) {
        event.preventDefault();
        return false;
      }
    });
};

window.initAccountValidation = function() {
  if (window.initFieldToggles) window.initFieldToggles();
};

$(document).on('turbolinks:load', function() {
  if ($('#user_password').length) {
    window.initPasswordValidation();
  }
  if ($('#user_first_name').length && !$('#user_password').length) {
    window.initAccountValidation();
  }
});
